<template>
  <div class="lrBox publicHvCenter">
    <div class="shade"></div>
    <div class="box">
      <div class="closeIconRound">
        <img
          src="@/assets/image/close.png"
          class="closeIcon"
          @click="closelrBox"
          alt="嗨喵悦动,嗨喵互动,关闭图标"
        />
      </div>
      <img
        src="@/assets/image/corner.png"
        class="qrIcon"
        v-if="lrType === 1 || lrType === 2"
        @click="openBoxByType(0)"
      />
      <div class="slogan">
        <img src="@/assets/2025home/login.png" alt="嗨喵悦动,嗨喵互动,登录" />
      </div>
      <div class="qrcodeForm publicVCenter" v-if="lrType === 0">
        <div class="welcome">
          <div class="decoration-left">
            <span class="line"></span>
            <span class="dot"></span>
          </div>
          <span class="welcome-text">Welcome</span>
          <div class="decoration-right">
            <span class="dot"></span>
            <span class="line"></span>
          </div>
        </div>
        <div class="tit">微信二维码登录</div>
        <div class="qrcodeBox publicHvCenter">
          <img :src="qrcodePath" v-show="qrcodePath" alt="嗨喵悦动,嗨喵互动,二维码登录" />
          <i class="el-icon-loading" v-show="!qrcodePath"></i>
        </div>
        <div class="tip">请使用微信扫码登录</div>
        <div class="otherLoginEntry" @click="openBoxByType(1)">其他方式登录</div>
        <!-- <router-link to="service" target="_blank">
          <div class="loginTip publicHCetner">
            若登录则表示已阅读并同意本网站的<label>用户协议</label>
          </div>
        </router-link> -->
        <div class="loginTip">
          若登录则表示已阅读并同意本网站的<label @click="openUserAgreement">《用户协议》</label>
        </div>
      </div>
      <div class="loginForm publicVCenter" :class="{ needSms: needSmsVerify }" v-if="lrType === 1">
        <div class="chooseType publicVCenter">
          <div class="item" @click="openBoxByType(2)">注册</div>
          <div class="item active">登录</div>
        </div>
        <div class="phoneInput">
          <el-input placeholder="手机号" v-model="phone" maxlength="11">
            <img
              slot="prefix"
              src="@/assets/2025home/sjh.png"
              class="input-icon"
              alt="手机号图标"
            />
          </el-input>
        </div>
        <div class="passwordInput">
          <el-input placeholder="密码" v-model="password" show-password maxlength="20">
            <img slot="prefix" src="@/assets/2025home/mm.png" class="input-icon" alt="密码图标" />
          </el-input>
        </div>
        <div class="validateCodeInput publicVCenter" v-if="needSmsVerify">
          <el-input placeholder="短信验证码" v-model="valiCode" maxlength="20">
            <img
              slot="prefix"
              src="@/assets/2025home/yzm.png"
              class="input-icon"
              alt="验证码图标"
            />
          </el-input>
          <div class="getValiCodeBtn" @click="getValidate('10')">
            {{ isCd ? cd : "获取验证码" }}
          </div>
        </div>
        <div class="forgetPwdEntry" @click="openBoxByType(3)">忘记密码</div>
        <div class="loginBtn publicHvCenter" @click="handleLogin">立即体验</div>
        <div class="otherLoginEtnry publicHCenter" @click="openBoxByType(0)">二维码登录</div>
        <!-- <router-link to="service" target="_blank">
          <div class="loginTip publicHCetner">
            若登录则表示已阅读并同意本网站的<label>用户协议</label>
          </div>
        </router-link> -->
        <div class="loginTip">
          若登录则表示已阅读并同意本网站的<label @click="openUserAgreement">《用户协议》</label>
        </div>
      </div>
      <div class="registerForm publicVCenter" v-if="lrType === 2">
        <div class="chooseType publicVCenter">
          <div class="item active">注册</div>
          <div class="item" @click="openBoxByType(1)">登录</div>
        </div>
        <div class="phoneInput">
          <el-input placeholder="手机号" v-model="phone" maxlength="11">
            <img
              slot="prefix"
              src="@/assets/2025home/sjh.png"
              class="input-icon"
              alt="手机号图标"
            />
          </el-input>
        </div>
        <div class="passwordInput">
          <el-input placeholder="密码" v-model="password" show-password maxlength="20">
            <img slot="prefix" src="@/assets/2025home/mm.png" class="input-icon" alt="密码图标" />
          </el-input>
        </div>
        <div class="inviteCodeInput">
          <el-input placeholder="邀请码" v-model="inviteCode" maxlength="20">
            <img
              slot="prefix"
              src="@/assets/2025home/yqm.png"
              class="input-icon"
              alt="邀请码图标"
            />
          </el-input>
        </div>
        <div class="captchaInput publicVCenter">
          <el-input placeholder="图形验证码" v-model="captchaCode" maxlength="10">
            <img
              slot="prefix"
              src="@/assets/2025home/yzm.png"
              class="input-icon"
              alt="验证码图标"
            />
          </el-input>
          <img
            class="captchaImg"
            :src="captchaImage"
            @click="fetchCaptcha"
            v-if="captchaImage"
            alt="图形验证码"
          />
          <div class="captchaImg captchaPlaceholder" @click="fetchCaptcha" v-else>
            <i class="el-icon-loading"></i>
          </div>
        </div>
        <div class="validateCodeInput publicVCenter">
          <el-input placeholder="短信验证码" v-model="valiCode" maxlength="20">
            <img
              slot="prefix"
              src="@/assets/2025home/yzm.png"
              class="input-icon"
              alt="验证码图标"
            />
          </el-input>
          <div class="getValiCodeBtn" @click="getValidate('1')">
            {{ isCd ? cd : "获取验证码" }}
          </div>
        </div>
        <div class="registerBtn publicHvCenter" @click="register">立即注册</div>
        <div class="otherLoginEtnry publicHCenter" @click="openBoxByType(0)">二维码登录</div>
        <!-- <router-link to="service" target="_blank">
          <div class="registerTip publicHCetner">
            若登录则表示已阅读并同意本网站的<label>用户协议</label>
          </div>
        </router-link> -->
        <div class="registerTip">
          若登录则表示已阅读并同意本网站的<label @click="openUserAgreement">《用户协议》</label>
        </div>
      </div>
      <div class="resetForm publicVCenter" v-if="lrType === 3">
        <div class="tit">重置密码</div>
        <div class="phoneInput">
          <el-input placeholder="手机号" v-model="phone" maxlength="11">
            <img
              slot="prefix"
              src="@/assets/2025home/sjh.png"
              class="input-icon"
              alt="手机号图标"
            />
          </el-input>
        </div>
        <div class="validateCodeInput publicVCenter">
          <el-input placeholder="短信验证码" v-model="valiCode" maxlength="20">
            <img
              slot="prefix"
              src="@/assets/2025home/yzm.png"
              class="input-icon"
              alt="验证码图标"
            />
          </el-input>
          <div class="getValiCodeBtn" @click="getValidate('2')">
            {{ isCd ? cd : "获取验证码" }}
          </div>
        </div>
        <div class="passwordInput">
          <el-input placeholder="请输入新密码" v-model="password" show-password maxlength="20">
            <img slot="prefix" src="@/assets/2025home/mm.png" class="input-icon" alt="密码图标" />
          </el-input>
        </div>
        <div class="resetBtn publicHvCenter" @click="changePwd">确认修改</div>
        <div class="otherLoginEtnry publicHCenter" @click="openBoxByType(0)">二维码登录</div>
        <!-- <router-link to="service" target="_blank">
          <div class="resetTip publicHCetner">
            若登录则表示已阅读并同意本网站的<label>用户协议</label>
          </div>
        </router-link> -->
        <div class="resetTip">
          若登录则表示已阅读并同意本网站的<label @click="openUserAgreement">《用户协议》</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getQrcode,
  getLoginStatus,
  scanLogin,
  inputLogin,
  register,
  sendCode,
  resetPassword,
  getGraphicCaptcha,
  sendSmsCodeWithCaptcha,
} from '@/api/index';
import { timeoutTask } from '@/utils/index';
import { HEADIMG } from '@/assets/constant/default';

let loopLock = false;
let btnLock = false;
export default {
  name: 'lrBox',
  components: {},
  data() {
    return {
      lrType: 0, // 0:二维码登录 1: 手机号登录 2: 注册 3: 重置密码
      openId: '',
      ext: '',
      codeId: '',
      phone: '',
      password: '',
      inviteCode: '',
      valiCode: '',
      captchaId: '',
      captchaImage: '',
      captchaCode: '',
      qrcodePath: '',
      isCd: false,
      cd: 60,
      needSmsVerify: false,
      loginSmsPhone: '',
    };
  },
  watch: {
    lrType: function lrType(newVal) {
      if (newVal !== 0) {
        loopLock = true;
      }
    },
  },
  created() {
    loopLock = false;
    btnLock = false;
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    closelrBox() {
      this.$emit('close');
      loopLock = true;
    },
    openBoxByType(type) {
      if (type === 0) {
        this.needSmsVerify = false;
        this.lrType = 0;
        this.requestQrcode();
      } else if (type === 1) {
        this.lrType = 1;
      } else if (type === 2) {
        this.needSmsVerify = false;
        this.lrType = 2;
        this.lrType = 2;
        this.fetchCaptcha();
      } else if (type === 3) {
        this.needSmsVerify = false;
        this.lrType = 3;
      }
    },
    requestQrcode() {
      if (btnLock) {
        return;
      }
      btnLock = true;
      getQrcode()
        .then((res) => {
          console.log(res);
          btnLock = false;
          this.qrcodePath = res.WXQRCodeUrl;
          return res.loginKey;
        })
        .then((res2) => {
          console.log(res2);
          loopLock = false;
          this.loopRequestLoginStatus(res2);
        })
        .catch((err) => {
          console.log(err);
          btnLock = false;
        });
    },
    loopRequestLoginStatus(pLoginKey) {
      if (loopLock) {
        return;
      }
      getLoginStatus(pLoginKey)
        .then((res) => {
          console.log(res);
          if (res.data.val === '0') {
            timeoutTask(() => {
              this.loopRequestLoginStatus(res.data.loginKey);
            }, 2000);
          } else if (res.data.val === '1') {
            loopLock = true;
            this.requestScanLogin(res.data.token);
          } else if (res.data.val === '2') {
            loopLock = true;
            this.$message('您还未拥有账号，请注册!');
            this.openId = res.data.openId;
            this.openBoxByType(2);
          } else {
            loopLock = true;
            this.$message.error('登录失败!');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    requestScanLogin(pToken) {
      scanLogin(pToken)
        .then((res) => {
          console.log(res);
          if (res.token) {
            window.location.href = `${window.location.origin}/hm-customer/index.html#/app/home`;
            this.$store.commit('updateUserInfo', {
              userName: res.emcee_name,
              headImg: res.avator,
              phone: res.phonenumber,
              token: res.token,
            });
            if (window.parent) {
              window.parent.postMessage(`token:${res.token}`, '*');
            }
          } else if (res.code === '500') {
            this.$message.error(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleLogin() {
      if (!this.phone) {
        this.$message.error('请输入手机号!');
        return;
      }
      if (this.phone.length !== 11) {
        this.$message.error('手机号格式错误!');
        return;
      }
      if (!this.password) {
        this.$message.error('请输入密码!');
        return;
      }
      if (this.needSmsVerify && this.phone !== this.loginSmsPhone) {
        this.needSmsVerify = false;
        this.valiCode = '';
        this.codeId = '';
      }
      if (this.needSmsVerify && !this.valiCode) {
        this.$message.error('请输入短信验证码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      const params = {
        phone: this.phone,
        password: this.password,
      };
      if (this.needSmsVerify) {
        params.code = this.valiCode;
        if (this.codeId) {
          params.codeId = this.codeId;
        }
      }
      inputLogin(params)
        .then((res) => {
          console.log(res);
          btnLock = false;
          const loginCode = String(res.code || '');
          if (res.token) {
            this.needSmsVerify = false;
            window.location.href = `${window.location.origin}/hm-customer/index.html#/app/home`;
            this.$store.commit('updateUserInfo', {
              userName: res.emcee_name,
              headImg: res.avator,
              phone: res.phonenumber,
              token: res.token,
            });
            if (window.parent) {
              window.parent.postMessage(`token:${res.token}`, '*');
            }
          } else if (loginCode === '201') {
            this.lrType = 1;
            this.needSmsVerify = true;
            this.loginSmsPhone = this.phone;
            this.valiCode = '';
            this.getValidate('10');
          } else if (loginCode === '202') {
            this.valiCode = '';
            this.codeId = '';
            this.$message.error(res.msg || '验证码错误或已用过，请重新获取');
          } else if (loginCode === '500') {
            this.$message.error(res.errMsg || res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          btnLock = false;
        });
    },
    getValidate(pSource) {
      if (this.isCd) {
        return;
      }
      if (!this.phone) {
        this.$message.error('请输入手机号!');
        return;
      }
      if (this.phone.length !== 11) {
        this.$message.error('手机号格式错误!');
        return;
      }
      if (pSource === '1') {
        if (!this.captchaCode) {
          this.$message.error('请输入图形验证码!');
          return;
        }
        if (btnLock) {
          return;
        }
        btnLock = true;
        sendSmsCodeWithCaptcha({
          phone: this.phone,
          source: '1',
          captchaId: this.captchaId,
          captchaCode: this.captchaCode,
        })
          .then((res) => {
            console.log(res);
            btnLock = false;
            if (res.code === '200') {
              this.ext = res.data.ext;
              this.codeId = res.data.codeId;
              this.$message({
                message: res.msg,
                type: 'success',
              });
              if (!this.isCd) {
                this.isCd = true;
                this.cd = 60;
                this.countDown();
              }
            } else {
              this.$message.error(res.msg);
              this.fetchCaptcha();
            }
          })
          .catch((err) => {
            console.log(err);
            btnLock = false;
          });
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      sendCode({
        phone: this.phone,
        source: pSource,
      })
        .then((res) => {
          console.log(res);
          btnLock = false;
          if (String(res.code) === '200') {
            this.ext = res.data && res.data.ext;
            this.codeId = res.data && res.data.codeId;
            this.$message({
              message: res.msg || res.message || '验证码已发送',
              type: 'success',
            });
            if (!this.isCd) {
              this.isCd = true;
              this.cd = 60;
              this.countDown();
            }
          } else {
            this.$message.error(res.msg || res.errMsg || res.message || '验证码发送失败');
          }
        })
        .catch((err) => {
          console.log(err);
          btnLock = false;
        });
    },
    fetchCaptcha() {
      this.captchaCode = '';
      getGraphicCaptcha()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.captchaId = res.data.captchaId;
            this.captchaImage = res.data.imageBase64;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    countDown() {
      if (this.cd === 0) {
        this.isCd = false;
        return;
      }
      this.cd -= 1;
      timeoutTask(() => {
        this.countDown();
      }, 1000);
    },
    changePwd() {
      if (!this.phone) {
        this.$message.error('请输入手机号!');
        return;
      }
      if (this.phone.length !== 11) {
        this.$message.error('手机号格式错误!');
        return;
      }
      if (!this.valiCode) {
        this.$message.error('请输入短信验证码!');
        return;
      }
      if (!this.password) {
        this.$message.error('请输入新密码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      resetPassword({
        phone: this.phone,
        password: this.password,
        codeId: this.codeId,
        ext: this.ext,
        valiCode: this.valiCode,
      })
        .then((res) => {
          console.log(res);
          btnLock = false;
          if (res.code === '200') {
            this.handleLogin();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          btnLock = false;
        });
    },
    register() {
      if (!this.phone) {
        this.$message.error('请输入手机号!');
        return;
      }
      if (this.phone.length !== 11) {
        this.$message.error('手机号格式错误!');
        return;
      }
      if (!this.password) {
        this.$message.error('请输入密码!');
        return;
      }
      if (!this.inviteCode) {
        this.$message.error('请输入邀请码!');
        return;
      }
      if (!this.valiCode) {
        this.$message.error('请输入短信验证码!');
        return;
      }
      if (btnLock) {
        return;
      }
      btnLock = true;
      register({
        phone: this.phone,
        password: this.password,
        inviteCode: this.inviteCode,
        valiCode: this.valiCode,
        ext: this.ext,
        codeId: this.codeId,
        openId: this.openId,
      })
        .then((res) => {
          console.log(res);
          btnLock = false;
          if (res.code === '500' || res.code === '400') {
            this.$message.error(res.errMsg);
          } else if (res.code === '200') {
            window.location.href = `${window.location.origin}/hm-customer/index.html#/app/home`;
            this.$store.commit('updateUserInfo', {
              userName: res.user_name,
              headImg: res.headimg_url || HEADIMG,
              phone: this.phone,
              token: res.token,
            });
            if (window.parent) {
              window.parent.postMessage(`token:${res.token}`, '*');
            }
          } else {
            this.$message.error('注册失败!');
          }
        })
        .catch((err) => {
          console.log(err);
          btnLock = false;
        });
    },
    openUserAgreement() {
      window.open('/service', '_blank');
    },
  },
};
</script>
<style lang="less" scoped>
.lrBox {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  .shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .box {
    width: 1000px;
    height: 584px;
    display: flex;
    position: relative;
    .closeIconRound {
      position: absolute;
      right: -40px;
      top: -40px;
      width: 41px;
      height: 41px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .closeIcon {
        width: 20px;
        height: 20px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .qrIcon {
      width: 93px;
      height: 78px;
      position: absolute;
      top: 0;
      right: 6px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .slogan {
      width: 409px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .qrcodeForm {
      width: 589px;
      height: 100%;
      flex-direction: column;
      background: #f9f9f9;

      .input-icon {
        width: 20px;
        height: 20px;
      }
      .welcome {
        margin-top: 38px;
        display: flex;
        align-items: center;
        justify-content: center;

        .decoration-left,
        .decoration-right {
          display: flex;
          align-items: center;

          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #feb342;
          }

          .line {
            width: 66px;
            height: 2px;
            background: #feb342;
          }
        }

        .decoration-left {
          margin-right: 30px;

          .dot {
            margin-left: 10px;
          }
        }

        .decoration-right {
          margin-left: 30px;

          .dot {
            margin-right: 10px;
          }
        }

        .welcome-text {
          font-size: 28px;
          font-weight: bold;
          color: #feb342;
        }
      }
      .tit {
        font-weight: bold;
        color: #000;
        font-size: 28px;
        margin-top: 42px;
      }
      .qrcodeBox {
        width: 236px;
        height: 236px;
        border: 1px solid #feb342;
        margin-top: 13px;
        .el-icon-loading {
          font-size: 38px;
          color: #feb342;
        }
        img {
          width: 212px;
          height: 212px;
        }
      }
      .tip {
        color: #83838b;
        font-weight: 400;
        font-size: 22px;
        margin-top: 10px;
      }
      .otherLoginEntry {
        font-size: 20px;
        font-weight: 400;
        color: #f7a121;
        margin-top: 6px;
        cursor: pointer;
      }
      .loginTip {
        width: 100%;
        margin-top: 50px;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #83838b;
        cursor: pointer;
        text-align: center !important;
        label {
          font-weight: 600;
          margin-left: 6px;
          color: #f7a121;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
    .loginForm {
      width: 587px;
      height: 100%;
      flex-direction: column;
      align-items: center;
      background: #ffffff;
      padding: 48px 90px 0 90px;

      .input-icon {
        width: 20px;
        height: 20px;
      }
      .chooseType {
        width: 100%;
        .item {
          font-weight: bold;
          color: #969696;
          font-size: 28px;
          cursor: pointer;
          &.active {
            font-weight: 500;
            color: #000;
            margin-left: 34px;
          }
        }
      }
      .phoneInput {
        margin-top: 29px;
        width: 100%;
      }
      .passwordInput {
        margin-top: 20px;
        width: 100%;
      }
      .el-input::v-deep {
        font-size: 18px;
        .el-input__inner {
          height: 50px;
          padding-left: 40px;
          &:focus {
            border-color: #f7a121;
          }
        }
        .el-input__prefix {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 100%;
        }
      }
      .validateCodeInput {
        margin-top: 20px;
        width: 100%;
        justify-content: flex-start;
        gap: 20px;
        .el-input::v-deep {
          width: 280px;
        }
        .getValiCodeBtn {
          font-weight: 400;
          font-size: 18px;
          color: #feb041;
          flex-shrink: 0;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .forgetPwdEntry {
        width: 100%;
        margin-top: 20px;
        font-weight: 400;
        color: #feb041;
        font-size: 18px;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      &.needSms {
        .loginBtn {
          margin-top: 24px;
        }
        .loginTip {
          margin-top: 36px;
        }
      }
      .loginBtn {
        width: 403px;
        height: 58px;
        background: linear-gradient(90deg, #f7a121 0%, #ffc74d 100%);
        border-radius: 29px 29px 29px 29px;
        color: #ffffff;
        font-weight: 500;
        font-size: 22px;
        margin-top: 44px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .otherLoginEtnry {
        font-weight: 400;
        color: #83838b;
        font-size: 20px;
        width: 100%;
        margin-top: 17px;
        cursor: pointer;
        &:hover {
          color: #f7a121;
        }
      }
      .loginTip {
        width: 100%;
        margin-top: 109px;
        font-size: 16px;
        font-weight: 400;
        color: #83838b;
        cursor: pointer;
        text-align: center !important;
        label {
          font-weight: 600;
          margin-left: 6px;
          color: #f7a121;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
    .registerForm {
      width: 587px;
      height: 100%;
      flex-direction: column;
      align-items: center;
      background: #ffffff;
      padding: 48px 90px 0 90px;

      .input-icon {
        width: 20px;
        height: 20px;
      }
      .chooseType {
        width: 100%;
        .item {
          font-weight: bold;
          color: #969696;
          font-size: 28px;
          cursor: pointer;
          &.active {
            font-weight: 500;
            color: #000;
            margin-right: 34px;
          }
        }
      }
      .phoneInput {
        margin-top: 20px;
        width: 100%;
      }
      .passwordInput {
        margin-top: 15px;
        width: 100%;
      }
      .inviteCodeInput {
        margin-top: 15px;
        width: 100%;
      }
      .captchaInput {
        margin-top: 15px;
        width: 100%;
        justify-content: flex-start;
        gap: 12px;
        .el-input::v-deep {
          width: 230px;
        }
        .captchaImg {
          height: 50px;
          width: 140px;
          cursor: pointer;
          border-radius: 4px;
          flex-shrink: 0;
          object-fit: contain;
          &:hover {
            opacity: 0.8;
          }
        }
        .captchaPlaceholder {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5;
          border: 1px solid #dcdfe6;
          .el-icon-loading {
            font-size: 20px;
            color: #feb041;
          }
        }
      }
      .validateCodeInput {
        margin-top: 15px;
        width: 100%;
        justify-content: flex-start;
        gap: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .el-input::v-deep {
          width: 280px;
        }
        .getValiCodeBtn {
          font-weight: 400;
          font-size: 18px;
          color: #feb041;
          flex-shrink: 0;
        }
      }
      .el-input::v-deep {
        font-size: 18px;
        .el-input__inner {
          height: 50px;
          padding-left: 40px;
          &:focus {
            border-color: #f7a121;
          }
        }
        .el-input__prefix {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 100%;
        }
      }
      .registerBtn {
        width: 403px;
        height: 58px;
        background: linear-gradient(90deg, #f7a121 0%, #ffc74d 100%);
        border-radius: 29px 29px 29px 29px;
        color: #ffffff;
        font-weight: 500;
        font-size: 22px;
        margin-top: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .otherLoginEtnry {
        font-weight: 400;
        color: #83838b;
        font-size: 20px;
        width: 100%;
        margin-top: 17px;
        cursor: pointer;
        &:hover {
          color: #f7a121;
        }
      }
      .registerTip {
        width: 100%;
        margin-top: 25px;
        font-size: 16px;
        font-weight: 400;
        color: #83838b;
        cursor: pointer;
        text-align: center !important;
        label {
          font-weight: 600;
          margin-left: 6px;
          color: #f7a121;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
        &:hover {
          color: #f7a121;
        }
      }
    }
    .resetForm {
      width: 587px;
      height: 100%;
      flex-direction: column;
      background: #f9f9f9;
      padding: 48px 90px 0 90px;

      .input-icon {
        width: 20px;
        height: 20px;
      }
      .tit {
        width: 100%;
        font-weight: bold;
        color: #000;
        font-size: 28px;
      }
      .phoneInput {
        margin-top: 29px;
        width: 100%;
      }
      .validateCodeInput {
        margin-top: 20px;
        width: 100%;
        justify-content: flex-start;
        gap: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .el-input::v-deep {
          width: 280px;
        }
        .getValiCodeBtn {
          font-weight: 400;
          font-size: 18px;
          color: #feb041;
          flex-shrink: 0;
        }
      }
      .passwordInput {
        margin-top: 20px;
        width: 100%;
      }
      .el-input::v-deep {
        font-size: 18px;
        .el-input__inner {
          height: 50px;
          padding-left: 40px;
          &:focus {
            border-color: #f7a121;
          }
        }
        .el-input__prefix {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 100%;
        }
      }
      .resetBtn {
        width: 403px;
        height: 58px;
        background: linear-gradient(90deg, #f7a121 0%, #ffc74d 100%);
        border-radius: 29px 29px 29px 29px;
        color: #ffffff;
        font-weight: 500;
        font-size: 22px;
        margin-top: 66px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .otherLoginEtnry {
        font-weight: 400;
        color: #83838b;
        font-size: 20px;
        width: 100%;
        margin-top: 17px;
        cursor: pointer;
        &:hover {
          color: #f7a121;
        }
      }
      .resetTip {
        width: 100%;
        margin-top: 60px;
        font-size: 16px;
        font-weight: 400;
        color: #83838b;
        cursor: pointer;
        text-align: center !important;
        label {
          font-weight: 600;
          margin-left: 6px;
          color: #f7a121;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
